const styles = `:host {
  display: flex;
}
:host .control {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 64px;
  height: inherit;
  min-width: 128px;
  box-sizing: border-box;
  padding: 11px 16px;
  white-space: inherit;
  text-align: left;
  max-width: 100%;
}
:host .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-size: 24px;
  margin: 0 0 var(--goto-spacing-01) 0;
}

:host([variant=primary]:not([disabled])) .control {
  background-color: var(--goto-tile-background);
  border-color: var(--goto-tile-border);
}

:host([variant=secondary]:not([disabled])) .control {
  background-color: var(--goto-tile-background-secondary);
  border-color: var(--goto-tile-border-secondary);
}

:host([variant=secondary]:not([disabled])) .control:hover {
  background-color: var(--goto-tile-background-secondary-hover);
}

:host([variant=secondary]:not([disabled])) .control:active {
  background-color: var(--goto-tile-background-secondary-active);
}

:host([variant=primary][selected]:not([disabled])) .control {
  background-color: var(--goto-tile-background-selected);
  border-color: var(--goto-tile-background-selected);
}

:host([variant=secondary][selected]:not([disabled])) .control {
  background-color: var(--goto-tile-background-selected);
  border-color: var(--goto-tile-background-selected);
}

:host([variant=primary]:not([disabled])) .control:hover,
:host([variant=secondary][selected]:not([disabled])) .control:hover {
  background-color: var(--goto-tile-background-hover);
  border-color: var(--goto-tile-background-hover);
}

:host([variant=primary]:not([disabled])) .control:active,
:host([variant=secondary][selected]:not([disabled])) .control:active {
  background-color: var(--goto-tile-background-active);
  border-color: var(--goto-tile-background-active);
}

:host([selected]) .control {
  background-color: var(--goto-interactive-01);
  border-color: var(--goto-interactive-01);
  color: var(--goto-text-06);
  --goto-icon-color: var(--goto-text-06);
}
:host([selected]) .control:hover {
  background-color: var(--goto-hover-primary);
  border-color: var(--goto-hover-primary);
}
:host([selected]) .control:active {
  background-color: var(--goto-pressed-primary);
  border-color: var(--goto-pressed-primary);
  box-shadow: none;
}
:host([selected]) .control:focus-visible {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([selected]) .control:-moz-focusring {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}
:host([selected]) .control:disabled {
  background-color: var(--goto-disabled-02);
  border-color: transparent;
  color: var(--goto-text-03);
  cursor: default;
  --goto-icon-color: var(--goto-text-03);
}
:host([selected]) .control .start,
:host([selected]) .control .end {
  display: flex;
  align-items: center;
}

:host([disabled]) .control {
  background-color: var(--goto-ui-01);
  border-color: var(--goto-border);
}
:host([disabled]) .control ::slotted(chameleon-svg[slot=start]) {
  --goto-icon-color: var(--goto-text-03);
}

:host([disabled][variant=primary]) .control {
  background-color: var(--goto-tile-background-disabled);
  border-color: var(--goto-tile-border-disabled);
}`; export default styles;